import { Router } from '@angular/router';
import { DataService } from '../../user-detail.service';
import * as i0 from "@angular/core";
import * as i1 from "@angular/router";
import * as i2 from "../../user-detail.service";
var BreaktimecebuGuard = /** @class */ (function () {
    function BreaktimecebuGuard(router, dataService) {
        this.router = router;
        this.dataService = dataService;
    }
    BreaktimecebuGuard.prototype.canActivate = function (next, state) {
        var branches = this.dataService.getStaffInformation.branches.map(function (branch) { return branch['name']; });
        if (branches.includes('セブ支店')) {
            return true;
        }
        else {
            this.router.navigate(['/attendance-record']);
            return false;
        }
    };
    BreaktimecebuGuard.ngInjectableDef = i0.defineInjectable({ factory: function BreaktimecebuGuard_Factory() { return new BreaktimecebuGuard(i0.inject(i1.Router), i0.inject(i2.DataService)); }, token: BreaktimecebuGuard, providedIn: "root" });
    return BreaktimecebuGuard;
}());
export { BreaktimecebuGuard };
